import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DateParsersService } from 'rev-shared/date/DateParsers.Service';
import { buildUrl, parseUrl } from 'rev-shared/util/UrlUtil';
import { WebcastVideoSource } from '../webcast/WebcastVideoSource';

const rtmp = 'rtmp';
const rtmps = 'rtmps';
const srt = 'srt';
const rtmpPort = '1937';
const rtmpsPort = '1936';
const srtPort = '9000';
@Injectable({
	providedIn: 'root'
})
export class RtmpVideoSourceDetailsService {
	constructor(
		private readonly DateParsers: DateParsersService,
		private readonly http: HttpClient
	) {}

	public getRtmpUrlDetails(isSecure: boolean, webcastType: WebcastVideoSource): Observable<{ url: string; streamKey: string }> {
		return this.http.post<{ url: string; streamKey: string }>(`/scheduled-events/rtmp-url`, {
			isSecure: (isSecure || 'false').toString(),
			sourceType: webcastType
		});
	}

	public getRtmpVideoSourceSchedules(startDateInIso: string, endDateInIso: string, url: string, webcastType: WebcastVideoSource): Observable<any> {
		return this.http.get<any>(`/scheduled-events/rtmp/schedule`, {
			params: {
				startDate: startDateInIso,
				endDate: endDateInIso,
				url,
				webcastType
			}
		}).pipe(
			map(events => (events || []).map(event => {
				return {
					...event,
					startDate: this.DateParsers.parseUTCDate(event.startDate),
					endDate: this.DateParsers.parseUTCDate(event.endDate)
				};
			}))
		);
	}
}

export function updateRtmpUrl(url: string, isSecure: boolean, streamKey: string, webcastType: WebcastVideoSource): string {
	const { host, path } = parseUrl(url);
	if (webcastType === WebcastVideoSource.SRT) {
		return buildUrl(
			srt,
			host,
			srtPort,
			`?passphrase=${streamKey}&pbkeylen=32`
		);
	}

	return buildUrl(
		isSecure ? rtmps : rtmp,
		host,
		isSecure ? rtmpsPort : rtmpPort,
		path
	);
}
